<div #content>
    <div class="d-flex flex-column flex-md-row top-nav-bar px-px-10">
        <a class="navbar-brand me-auto text-white align-middle" href="#">
            <img src="/assets/BNPP_Logo.png" class="d-inline-block align-top" alt="">
        </a>


        <nav class="my-2 my-md-0 cursor-default">
            <span class="color-white">{{lastPricingExecDate}}</span>

            <a class="v-divider px-mx-10 cursor-default"></a>

            <a class="icon-link cursor-pointer" routerLink="/visualisations" *ngIf="isAdmin">
                <img src="/assets/visu_icon.png" alt="Visualisations" class="visu-icon">
            </a>

            <!-- Settings icon -->
            <a class="icon-link cursor-pointer" (click)="openSetting()" *ngIf="isSuperAdmin">
                <!--<img src="/assets/Icon_Settings.svg"  alt="Settings">-->
                <svg width="16" height="16" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="194 0 34 34"
                    enable-background="new 194 0 34 34" xml:space="preserve">
                    <g>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M228,14.9v4.2h-4.4c-0.3,1.9-1.1,3.6-2.1,5.1l4.5,3.9l-3.1,3.8l-4.9-4.3
                            c-1.4,0.9-3,1.6-4.8,1.9V34h-4.3v-4.4c-1.8-0.3-3.4-1-4.8-1.9l-4.9,4.3l-3.1-3.8l4.5-3.9c-1-1.5-1.8-3.2-2.1-5.1H194v-4.2h4.4
                            c0.3-1.9,1.1-3.6,2.1-5.1l-4.5-3.9l3.1-3.8l4.9,4.3c1.4-0.9,3-1.6,4.8-1.9V0h4.3v4.5c1.8,0.3,3.4,1,4.8,1.9l4.9-4.3l3.1,3.8
                            l-4.5,3.9c1.1,1.5,1.8,3.2,2.1,5.1H228z M211,7.8c-5.1,0-9.2,4.1-9.2,9.2s4.1,9.2,9.2,9.2c5.1,0,9.2-4.1,9.2-9.2S216.1,7.8,211,7.8
                            " />
                    </g>
                </svg>
            </a>


            <!-- Help icon -->
            <a class="icon-link cursor-pointer" (click)="openDerivativesSetting()">
                <svg width="16" height="16" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16"
                    enable-background="new 0 0 16 16" xml:space="preserve">
                    <g>
                        <path d="M8,0C3.6,0,0,3.6,0,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8S12.5,0,8,0z M8,13.2c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3
                            s1.3,0.6,1.3,1.3C9.3,12.7,8.8,13.2,8,13.2z M11,5.6c0,0.2-0.1,0.4-0.3,0.6c-0.1,0.2-0.3,0.4-0.5,0.6C10,7,9.8,7.2,9.6,7.3
                            C9.5,7.5,9.3,7.6,9.2,7.7C9,7.8,8.9,8,8.9,8C8.8,8.1,8.8,8.3,8.7,8.4c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.3s0,0.2,0.1,0.3
                            c0,0,0,0.5-0.8,0.5S7.1,9.4,7.1,9.4C7,9.3,7,9.2,7,9c0-0.1,0-0.3,0-0.4c0-0.2,0-0.4,0-0.6c0-0.2,0.1-0.3,0.2-0.5
                            c0.1-0.1,0.2-0.3,0.3-0.4C7.6,7,7.7,6.9,7.9,6.7C8,6.6,8.2,6.4,8.3,6.4C8.4,6.2,8.5,6.1,8.6,6s0.1-0.2,0.2-0.4c0-0.1,0-0.3,0-0.4
                            c0-0.1,0-0.3-0.1-0.4C8.6,4.5,8.6,4.5,8.6,4.5L8.3,4.2c0,0-0.1,0-0.4-0.1C7.6,4.1,7.2,4.2,6.8,4.4C6.4,4.5,6.1,4.8,5.7,5
                            C5.7,5,5,4.8,5,4s0.7-1,0.7-1c0.3-0.2,0.7-0.4,1.1-0.5c0.4-0.1,0.8-0.1,1.3-0.1c0.4,0,0.8,0,1.2,0.1C9.7,2.7,10,2.8,10.3,3
                            c0.3,0.2,0.5,0.4,0.6,0.8C11,4,11.1,4.4,11.1,4.8C11.1,5.1,11,5.4,11,5.6z" />
                    </g>
                </svg>
            </a>

            <div class="dropdown">
                <button class="user-profil-icon">
                    <a class="icon-link  cursor-pointer">
                        <svg width="16" height="16" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 34 34"
                            enable-background="new 0 0 34 34" xml:space="preserve">
                            <path d="M17,0c-4.7,0-8.5,3.8-8.5,8.5c0,2.4,0.7,5.5,2.2,8c1.5,2.5,3.5,4.3,6.4,4.3c2.8,0,4.9-1.8,6.3-4.3c1.4-2.5,2.2-5.6,2.2-8
                                C25.5,3.8,21.7,0,17,0z" />
                            <path d="M21.6,20.2c-1.3,1-2.8,1.7-4.6,1.7c-1.8,0-3.3-0.6-4.5-1.6c-0.1,0.3-0.2,0.5-0.3,0.7c-0.2,0.4-0.6,0.8-1.1,1
                                c-1.5,0.6-4,0.7-6.3,1.4c-2.2,0.7-4.2,1.8-4.9,4.3c9.4,8.3,24.6,8.3,34,0c-0.6-2.4-2.6-3.6-4.9-4.3c-2.3-0.7-4.8-0.9-6.3-1.4
                                c-0.5-0.2-0.8-0.6-1-1C21.7,20.7,21.7,20.5,21.6,20.2L21.6,20.2z" />
                        </svg>
                    </a>
                </button>
                <div class="dropdown-content" >
                    <a  (click)="logOut()">
                        Logout</a>
                </div>
            </div>
            
            <a class="v-divider px-mx-10 cursor-default"></a>
            <a class="img-icon-link cursor-pointer" href="">
                <img src="/assets/CCR_Logo.png" alt="CCR">
            </a>
        </nav>
    </div>

    <app-nav></app-nav>
    <app-tool-bar></app-tool-bar>
    <router-outlet></router-outlet>
    <app-notification-panel></app-notification-panel>
    <app-notification-alert class="notification-alert position-absolute d-block"></app-notification-alert>
</div>
<div [style.height.px]="computeMinHeight()" class="d-flex d-flex flex-column justify-content-end align-items-start">
    <div class="w-100 d-flex d-flex flex-row justify-content-between align-items-center top-nav-bar px-py-0 px-px-10">
        <a class="navbar-brand me-auto text-white align-middle px-py-0" href="#">
            <img src="/assets/BNPP_Logo.png" class="d-inline-block align-top" alt="">
        </a>
        <nav class="d-flex flex-row justify-content-center align-items-center">
            <!-- <p class="text-white px-mr-110 fs-11px main_style version">Angular Version : {{ angularVersion }}</p> -->
            <a class="cursor-pointer text-white px-mr-110 fs-11px main_style"
                href="https://securities.cib.bnpparibas/data-protection-notice" target="_blank">Data Protection
                Notice</a>
            <a class="cursor-pointer text-white px-mr-110 fs-11px main_style"
                href="/assets/policy/Cookies_Policy_LIGHT_FRANCE_(EN)_vDEF.docx" target="_blank">Cookies Policy
                (English)</a>
            <a class="cursor-pointer text-white px-mr-110 fs-11px main_style"
                href="/assets/policy/Politique_Cookies_LIGHT_FRANCE_(FR)_vDEF.docx" target="_blank">Politique des
                Cookies (Français)</a>
            <a class="cursor-pointer text-white px-mr-110 fs-11px main_style"
                href="https://securities.cib.bnpparibas/en/legal-information" target="_blank">Legal Information</a>
            <!--a class="cursor-pointer text-white px-mr-110 fs-11px" style="letter-spacing: 2px; padding-bottom: 8px;" href="/assets/static/en/legal-information/legal-information.html" target="_blank">Legal Information</a-->
        </nav>
    </div>
</div>